import { IAppointmentRequestParams } from "../../interfaces/api/albus/appointment"

class AppointmentScheduleRequestParamsBuilder {
	appointmentScheduleRequestParams: IAppointmentRequestParams

	constructor() {
		this.appointmentScheduleRequestParams = {
			appointmentId: null,
			patientId: null,
			customerId: null,
			centerId: null,
			doctorId: null,
			nurseId: null,
			roomId: null,
			startTimeEpoch: null,
			numOfDays: null,
			status: null,
			statusList: null,
			isPrescriptionRequired: false,
			isPatientExaminationsRequired: false,
			isDoctorRequired: false,
			isNurseRequired: false,
			isPatientRequired: false,
			isTeleconsultationRequired: false,
			isConsultationTypeRequired: false,
			isConsultationProductRequired: false,
			isRoomRequired: false,
			isAppointmentContextRequired: false,
			isBookingRequired: false,
			isRootBookingRequired: false,
			chatUserType: null,
			pageNo: null,
			pageSize: null,
			isMentalExaminationsRequired: false,
			isOrderAssetsRequired: false,
			isAvailableDoctorActionRequired: false,
			prescriptionEditContextRequired: false,
			isPackInfoRequired: false,
			tillTimeEpoch: null,
			isOrderEventLoggingRequired: false,
			isAudioRecordingUrlRequired: false,
			isDoctorTransferRequired: false,
			isStateInfoRequired: false,
			isAudioCallTaskSummaryRequired: false,
			doctorTypeCode: null,
			isConsultTagsRequired: false,
		}
	}

	setTillTimeEpoch(epoch: number) {
		this.appointmentScheduleRequestParams.tillTimeEpoch = epoch
		return this
	}

	setIsStateInfoRequired(flag: boolean) {
		this.appointmentScheduleRequestParams.isStateInfoRequired = flag
		return this
	}

	setIsAudioCallTaskSummaryRequired(flag: boolean) {
		this.appointmentScheduleRequestParams.isAudioCallTaskSummaryRequired = flag
		return this
	}

	setOrderAssetsRequired() {
		this.appointmentScheduleRequestParams.isOrderAssetsRequired = true
		return this
	}

	setAppointmentId(appointmentId: number) {
		this.appointmentScheduleRequestParams.appointmentId = appointmentId
		return this
	}

	setPatientId(patientId: number) {
		this.appointmentScheduleRequestParams.patientId = patientId
		return this
	}

	setCustomerId(customerId: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.customerId = customerId
		return this
	}

	setCenterId(centerId: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.centerId = centerId
		return this
	}

	setNurseId(nurseId: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.nurseId = nurseId
		return this
	}

	setDoctorId(doctorId: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.doctorId = doctorId
		return this
	}

	setRoomId(roomId: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.roomId = roomId
		return this
	}

	setStartTimeEpoch(startTimeEpoch: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.startTimeEpoch = startTimeEpoch
		return this
	}

	setNumOfDays(numOfDays: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.numOfDays = numOfDays
		return this
	}

	setStatus(status: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.status = status
		return this
	}

	setPrescriptionRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isPrescriptionRequired = true
		return this
	}

	setPatientExaminationsRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isPatientExaminationsRequired = true
		return this
	}

	setDoctorRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isDoctorRequired = true
		return this
	}

	setNurseRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isNurseRequired = true
		return this
	}

	setRoomRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isRoomRequired = true
		return this
	}

	setPatientRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isPatientRequired = true
		return this
	}

	setTeleconsultationRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isTeleconsultationRequired = true
		return this
	}

	setConsultationTypeRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isConsultationTypeRequired = true
		return this
	}

	setConsultationProductRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isConsultationProductRequired = true
		return this
	}

	setAppointmentContextRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isAppointmentContextRequired = true
		return this
	}

	setRootBookingRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isRootBookingRequired = true
		return this
	}

	setBookingRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isBookingRequired = true
		return this
	}

	setUserType(userType: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.chatUserType = userType
		return this
	}

	setSortBy(item: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.sortBy = item
		return this
	}

	setSortOrder(order: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.sortOrder = order
		return this
	}

	setPageNo(pageNo: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.pageNo = pageNo
		return this
	}

	setPageSize(pageSize: number): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.pageSize = pageSize
		return this
	}

	setMentalStatusRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isMentalExaminationsRequired = true
		return this
	}

	setIsAvailableDoctorActionRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isAvailableDoctorActionRequired = true
		return this
	}

	setPrescriptionEditContextRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.prescriptionEditContextRequired = true
		return this
	}

	setCompletedConsultationInMovingWindow(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.showCompletedConsultationInMovingWindow = true
		return this
	}

	setOngoingConsultationInMovingWindow(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.showOngoingConsultationInMovingWindow = true
		return this
	}

	setUpcomingConsultation(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.showUpcomingConsultation = true
		return this
	}

	setPackInfoRequired(isPackInfoRequired: boolean): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isPackInfoRequired = isPackInfoRequired
		return this
	}

	setIsOrderEventLoggingRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isOrderEventLoggingRequired = true
		return this
	}

	setIsAudioRecordingUrlRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isAudioRecordingUrlRequired = true
		return this
	}

	setIsDoctorTransferRequired(): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isDoctorTransferRequired = true
		return this
	}

	setDoctorTypeCode(doctorTypeCode: string): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.doctorTypeCode = doctorTypeCode
		return this
	}

	setStatusList(statusList: string[]): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.statusList = statusList
		return this
	}

	setIsConsultTagsRequired(isConsultTagsRequired: boolean): AppointmentScheduleRequestParamsBuilder {
		this.appointmentScheduleRequestParams.isConsultTagsRequired = isConsultTagsRequired
		return this
	}

	build(): IAppointmentRequestParams {
		return this.appointmentScheduleRequestParams
	}
}

export default AppointmentScheduleRequestParamsBuilder
